import buildSimpleStringFilter from '../buildSimpleStringFilter'

const modelFilter = buildSimpleStringFilter({
  key: 'model',
  expandedOnInit: false,
})

export default modelFilter
